<template>
<div class="container-fluid">
    <div class="d-flex align-items-center">
        <h2 class="page-heading mr-auto">Поиск</h2>

        <server-select
            v-if="true"
            class="select-machines-orders-ingredients-create mr-auto mw-50"
            v-model="selectedRegion"
            :custom-label="searchText"
            endpoint="billing/regions/list"
        />
    </div>
    <div class="card mb-3" v-if="selectedRegion === null">
        <h3 class="card-header"><span class="text-caps">Поиск организации...</span></h3>
        <div class="search-block row">
            <svg viewbox="0 0 128 128" width="100%" height="100%">
                <path class="doc" d="M0-0.00002,0,3.6768,0,124.32,0,128h4.129,119.74,4.129v-3.6769-120.65-3.6768h-4.129-119.74zm8.2581,7.3537,111.48,0,0,113.29-111.48,0zm13.626,25.048,0,7.3537,57.806,0,0-7.3537zm0,19.12,0,7.3537,84.232,0,0-7.3537zm0,17.649,0,7.3537,84.232,0,0-7.3537zm0,19.12,0,7.3537,84.232,0,0-7.3537z7z"/>
                <path class="magnify" d="M38.948,10.429c-18.254,10.539-24.468,33.953-14.057,51.986,9.229,15.984,28.649,22.764,45.654,16.763-0.84868,2.6797-0.61612,5.6834,0.90656,8.3207l17.309,29.98c2.8768,4.9827,9.204,6.6781,14.187,3.8013,4.9827-2.8768,6.6781-9.204,3.8013-14.187l-17.31-29.977c-1.523-2.637-4.008-4.34-6.753-4.945,13.7-11.727,17.543-31.935,8.31-47.919-10.411-18.034-33.796-24.359-52.049-13.82zm6.902,11.955c11.489-6.633,26.133-2.7688,32.893,8.9404,6.7603,11.709,2.7847,26.324-8.704,32.957-11.489,6.632-26.133,2.768-32.893-8.941-6.761-11.709-2.785-26.324,8.704-32.957z"/>
            </svg>
        </div>
    </div>
    <div class="row" v-if="selectedRegion !== null">
        <div class="col-lg-2 col-sm-2">
            <div class="card mb-4">
                <h3 class="card-header"><span class="text-caps">Аккаунт</span></h3>
                <div class="card-body">
                    <div class="d-flex flex-column">
                        <btn-action :disabled="selectedRegion === null" class="btn btn-primary mb-2" @click="authInRegion()">Войти</btn-action>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-sm-2">
            <div class="card mb-4">
                <h3 class="card-header"><span class="text-caps">Баланс</span></h3>
                <div class="card-body">
                    <div class="d-flex flex-column">
                        <btn-action :disabled="selectedRegion === null" class="btn btn-primary mb-2" @click="refillModalOpen()">Пополнить</btn-action>
                        <btn-action :disabled="selectedRegion === null" class="btn btn-primary" @click="writeOffModalOpen()">Списать</btn-action>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-sm-2">
            <div class="card mb-4">
                <h3 class="card-header"><span class="text-caps">Тариф</span></h3>
                <div class="card-body">
                    <div class="d-flex flex-column">
                        <btn-action :disabled="selectedRegion === null" class="btn btn-primary mb-2" @click="editTariffModalOpen()">Изменить</btn-action>
                        <btn-action :disabled="selectedRegion === null" class="btn btn-primary" @click="giveDiscountModalOpen()">Скидка</btn-action>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-2 col-lg-4 col-sm-4">
            <div class="card mb-4">
                <h3 class="card-header"><span class="text-caps">Основные данные</span></h3>
                <div class="card-body">
                    <div class="d-flex flex-column">
                        <btn-action :disabled="selectedRegion === null" class="btn btn-primary mb-2" @click="editShortNameModalOpen()">Короткое название</btn-action>
                        <btn-action :disabled="selectedRegion === null" class="btn btn-primary" @click="editGmtModalOpen()">Часовой пояс</btn-action>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card mb-3" v-if="selectedRegion !== null">
    <h3 class="card-header"><span class="text-caps">Организация</span></h3>
    <div class="card-body d-flex flex-wrap justify-content-between">
        <div class="field-show">
            <label>Полное название:</label>{{selectedRegion.name | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Короткое название:</label>{{selectedRegion.short_name | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Тариф (выбранный):</label>{{selectedRegion.subscription | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Тариф (действующий):</label>{{selectedRegion.current_subscription | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Баланс:</label>{{selectedRegion.money | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Скидка:</label>{{selectedRegion.sale | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Руководитель:</label>{{selectedRegion.director_name | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Email:</label>{{selectedRegion.director_email | checkNullOrNot}}
        </div> 
        <div class="field-show">
            <label>Часовой пояс:</label>{{selectedRegion.gmt | checkNullOrNot}}
        </div> 
    </div>
    </div>
</div>
</template>

<script>
import api from '@/api'
import refillModal from '../../../components/billing/modals/region-refill-balance.vue'
import writeOffModal from '../../../components/billing/modals/region-write-off-balance.vue'
import editTariffModal from '../../../components/billing/modals/region-edit-tariff.vue'
import giveDiscountModal from '../../../components/billing/modals/region-give-discount.vue'
import editGmtModal from '../../../components/billing/modals/region-edit-gmt.vue'
import editShortNameModal from '../../../components/billing/modals/region-edit-short-name.vue'

export default {
    metaInfo: {title: 'Организации'},
    data () {
        return {
            selectedRegion: null,
            oldSelectedRegion: null,
            regionsList: [],
        }
    },
    methods: {
        searchText (region) {
            return region.short_name + ' (' + region.director_name + ') [' + region.director_email + ']'
        },
        authInRegion () {
            window.location.href = `/api/admin/billing/auth/login/${this.selectedRegion.director_email}`
        },
        toRegion () {
            this.$router.push({ path: `/region/${this.selectedRegion.id}` })
        },
        refillModalOpen () {
            this.$root.showModal(refillModal, {
                region: this.selectedRegion,
            }).then((data) => {
                this.refreshRegionData(this.selectedRegion.id)
            })
        },
        writeOffModalOpen () {
            this.$root.showModal(writeOffModal, {
                region: this.selectedRegion,
            }).then((data) => {
                this.refreshRegionData(this.selectedRegion.id)
            })
        },
        editTariffModalOpen () {
            this.$root.showModal(editTariffModal, {
                region: this.selectedRegion,
            }).then((data) => {
                this.refreshRegionData(this.selectedRegion.id)
            })
        },
        giveDiscountModalOpen () {
            this.$root.showModal(giveDiscountModal, {
                region: this.selectedRegion,
            }).then((data) => {
                this.refreshRegionData(this.selectedRegion.id)
            })
        },
        editGmtModalOpen () {
            this.$root.showModal(editGmtModal, {
                region: this.selectedRegion,
            }).then((data) => {
                this.refreshRegionData(this.selectedRegion.id)
            })
        },
        editShortNameModalOpen () {
            this.$root.showModal(editShortNameModal, {
                region: this.selectedRegion,
            }).then((data) => {
                this.refreshRegionData(this.selectedRegion.id)
            })
        },
        refreshRegionData(region_id) {
            this.oldSelectedRegion = this.selectedRegion
            this.selectedRegion = null
            api.get(`billing/regions/list?region_id=`+region_id)
            .then(data => {
                this.selectedRegion = data.data
            })
        }
    },
    watch: {
    },
    filters: {
        checkNullOrNot: function (text) {
            if (text === null) return '-=-=-'
            else return text
        },
    },
    mounted: function () {
    // api.get(`pabadmin`)
    //   .then(data => {
    //     this.logList = data.data.data
    //     console.log(data.data.data)
    //   })
    },
    asyncComputed: {
    },
}
</script>


<style lang="scss" scoped>
    .search-block {
        height: 60vh;
    }
    svg{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%);
    max-width:128px;
    max-height:128px;
    }
    .magnify{
    fill:#00a0e3;
    animation:search 1s infinite ease;
    }
    .doc{
    fill:#00a0e3;
    animation:flyby 1s infinite ease;
    }


    @keyframes search {
    0%{
        transform:translate(40px, 40px) scale(.6);
    }
    50%{
        transform:translate(20px, 20px) scale(.6);
    }
    100%{
        transform:translate(40px, 40px) scale(.6);
    }
    }

    @keyframes flyby {
    0%{
        transform:translate(-20px, 20px) scale(.2);
        opacity:0
    }
    50%{
        transform:translate(30px, 20px) scale(.5);
        opacity:1
    }
    100%{
        transform:translate(100px, 20px) scale(.2);
        opacity:0
    }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/organizations/search.vue